import { createSelector } from '@ngrx/store';
import * as fromFeature from '../../reducers.index';
import { Culture } from '@boels/models';
import { getCultureEntities } from '../../site-context/selectors/site-context.selectors';

export const getCultureState = createSelector(
  fromFeature.getStoreState,
  (state: fromFeature.BoelsState) => state?.cultures,
);
export const getCultureWithState = createSelector(
  fromFeature.getStoreState,
  getCultureEntities,
  (state: fromFeature.BoelsState, isocodes: string[]) => {
    const cultures: Culture[] = [];
    for (const currentIso of isocodes) {
      cultures.push(<Culture>{
        isocode: currentIso,
        isActive: currentIso === state?.cultures.activeCulture,
      });
    }
    return cultures;
  },
);

export const getActiveCulture = createSelector(
  getCultureState,
  (state) => state?.activeCulture,
);

export const getActiveCurrency = createSelector(
  getCultureState,
  (state) => state?.activeCurrency,
);

export const getActiveLanguage = createSelector(
  getCultureState,
  (state) => state?.activeLanguage,
);
